import { render, staticRenderFns } from "./promo-sales-timed.vue?vue&type=template&id=2b5cfb10&"
import script from "./promo-sales-timed.vue?vue&type=script&lang=js&"
export * from "./promo-sales-timed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports